import React, { FC } from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { Button, makeStyles } from '@material-ui/core';
import { darken, fade } from '@material-ui/core/styles';
import classNames from 'classnames';

interface Props extends ButtonProps {
  rounded?: boolean;
  dark?: boolean;
}

const useStyles = makeStyles(theme => ({
  button: {
    width: 100,
    color: theme.palette.primary.main,
    backgroundColor: fade(theme.palette.primary.main, 0.1),
    '&:hover': {
      color: fade(theme.palette.primary.main, 0.5),
      backgroundColor: fade(theme.palette.primary.main, 0.2),
    },
  },
  rounded: {
    borderRadius: theme.spacing(4),
  },
  dark: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.common.white,
      backgroundColor: darken(theme.palette.primary.main, 0.1),
    },
  },
}));

const Primary: FC<Props> = ({ children, rounded, dark, ...rest }) => {
  const classes = useStyles();

  return (
    <Button
      className={classNames(classes.button, {
        [classes.rounded]: rounded,
        [classes.dark]: dark && !rest.disabled,
      })}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default Primary;
